import { AbstractDepartmentModel } from "@app/catalog-common";

export class SelectDepartmentMessage {
  selected: AbstractDepartmentModel;

  constructor(selected: AbstractDepartmentModel) {
    if (selected != undefined) {
      this.selected = selected;
    }
  }
}